export default __webpack_public_path__ + "static/media/blip-satisfact.5d49ca52.svg";